<template>
  <div>
    <div class="row" >
      <div class="col-md-12">
        <h2>Project: <code class="text-center text-warning">{{projectName}}</code></h2>
      </div>
    </div>
    <div class="row" >
      <div class="col-md-12">
        <inventorization-table :data="data" :old-data="oldData" :amount-rows="amount" :current="currentProject" @save-data="saveData"></inventorization-table>
      </div>
    </div>
  </div>
</template>

<script>
    import InventorizationTable from "../Inventorization/Table";
    import axios from "axios";
    import {setCookie, url} from "../../plugins/axios";
    import NotificationTemplate from "../Notifications/NotificationTemplate";
    export default {
      name: "inventory",
      components: {InventorizationTable},
      data(){
        return{
          currentProject: 0,
          projectName: '',
          data: [],
          oldData: [],
          amount: 0,
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        saveData(newData){
          if (newData.length !== 0){
            axios
              .put(url + 'update-inventory/',
                {data: newData},
                {
                  withCredentials:'include',
                  crossDomain:true
                })
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success','Data was updated');
                  this.getData(this.currentProject)
                }
                else{
                  if (response.data.error === 'Session is over'){
                    setCookie('Authentication','Failed',1);
                    this.$router.push('/login');
                  }
                  else{
                    this.notifyVue('danger',response.data.error);
                  }
                }
              })
              .catch((error) =>{
                this.notifyVue('danger',error);
              })
          }
          this.notifyVue('success','Data was updated');
        },
        getData(id){
          axios
            .get(url + 'inventory/' + id + '/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.data = response.data.result;
                for(let index in this.data){
                  let date = new Date(this.data[index]['date'].split('-').join('/') + " ");
                  this.data[index]['date'] = date.toLocaleDateString();
                }
                this.amount = (this.data !== null) ? this.data.length : 0;
                this.oldData = JSON.parse(JSON.stringify(this.data));
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
      },
      created() {
        const params = this.$route.query;
        this.currentProject = params.projectId;
        this.projectName = params.projectName.split('_').join(' ');
        this.getData(this.currentProject);
      }
    }
</script>

<style scoped>

</style>
